import { Alert, Button, Modal } from 'react-bootstrap';

const ComprobanteViewer = ({ show, onHide, comprobanteData }) => {
    if (!comprobanteData) return null;

    const handlePrint = (id) => {
        // Use logic passed id or default from single object
        const targetId = id || comprobanteData.comprobante_id;
        const printUrl = `/api/comprobantes/${targetId}/imprimir`;
        const width = 400;
        const height = 600;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;

        window.open(
            printUrl,
            'Imprimir Comprobante',
            `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`
        );
    };

    const isMultiple = comprobanteData.multiple && Array.isArray(comprobanteData.comprobantes);

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{isMultiple ? 'Pagos Registrados' : 'Pago Registrado'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
                <div className="mb-4">
                    <i className="fa fa-check-circle text-success" style={{ fontSize: '4rem' }}></i>
                </div>
                <h4 className="text-success mb-3">¡{isMultiple ? 'Pagos realizados' : 'Pago realizado'} con éxito!</h4>

                {isMultiple ? (
                    <>
                        <p>Se han generado los siguientes comprobantes:</p>
                        <div className="d-flex flex-column gap-2 mt-3" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            {comprobanteData.comprobantes.map((comp, idx) => (
                                <div key={idx} className="d-flex justify-content-between align-items-center p-2 border rounded">
                                    <span className="fw-bold">{comp.numero}</span>
                                    <Button size="sm" variant="outline-primary" onClick={() => handlePrint(comp.id)}>
                                        <i className="fa fa-print me-1"></i> Imprimir
                                    </Button>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        <p>Se ha generado el comprobante:</p>
                        <h3 className="mb-4">{comprobanteData.numero_completo}</h3>
                        <Alert variant="info">
                            El comprobante está listo para ser impreso.
                        </Alert>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
                {!isMultiple && (
                    <Button variant="primary" onClick={() => handlePrint()}>
                        <i className="fa fa-print me-2"></i>
                        Imprimir Comprobante
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ComprobanteViewer;
